<template>
  <img src="@/assets/images/logos/company-logo-qazindustry.webp"/>
</template>
<script setup>
</script>